export const SERVER_URL = 'https://fragment-online.com/api';

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
